import { FC, PropsWithChildren } from "react";
import { Transition, TransitionRootProps } from "@headlessui/react";

export const Dialog: FC<PropsWithChildren<TransitionRootProps>> = ({
  children,
  ...props
}) => {
  return (
    <Transition {...props}>
      <div className="transition">{children}</div>
    </Transition>
  );
};
